// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Scaffold from "../../bundles/Scaffold/Scaffold.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as CatalogProduct from "../../modules/Catalog/CatalogProduct.res.js";
import * as AmountTableCell from "../../modules/TableCell/AmountTableCell.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as LegacyProductReferenceTableCell from "../../modules/Product/LegacyProductReferenceTableCell.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query AnalyticsTopPerformingProductsPageQuery($filterBy: TopPerformingProductsQueryFilter, $sortBy: TopPerformingProductsQuerySort)  {\ntopPerformingProducts(filterBy: $filterBy, sortBy: $sortBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nmargin  \nmarginRate  \nmarkupRate  \ntotalPurchaseCost  \nrevenueIncludingTaxes  \nrevenueExcludingTaxes  \noccurrences  \nquantity  \ncapacityPrecision  \ncapacityUnit  \nname  \ncolor  \nkind  \nstockRawQuantity  \nstockKeepingUnit  \npurchasedPrice  \ncku  \ndescription  \nvariantId  \n}\n\n}\n\ntotalCount  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.topPerformingProducts;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    topPerformingProducts: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.capacityPrecision;
        let value$3 = value$1.capacityUnit;
        let value$4 = value$1.color;
        let tmp;
        if (value$4 == null) {
          tmp = undefined;
        } else {
          let tmp$1;
          switch (value$4) {
            case "AMBER" :
              tmp$1 = "AMBER";
              break;
            case "BLACK" :
              tmp$1 = "BLACK";
              break;
            case "BLOND" :
              tmp$1 = "BLOND";
              break;
            case "DARK" :
              tmp$1 = "DARK";
              break;
            case "ORANGE" :
              tmp$1 = "ORANGE";
              break;
            case "RED" :
              tmp$1 = "RED";
              break;
            case "ROSE" :
              tmp$1 = "ROSE";
              break;
            case "WHITE" :
              tmp$1 = "WHITE";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp = tmp$1;
        }
        let value$5 = value$1.kind;
        let tmp$2;
        switch (value$5) {
          case "BEER" :
            tmp$2 = "BEER";
            break;
          case "SIMPLE" :
            tmp$2 = "SIMPLE";
            break;
          case "SPIRITUOUS" :
            tmp$2 = "SPIRITUOUS";
            break;
          case "WINE" :
            tmp$2 = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$6 = value$1.stockRawQuantity;
        let value$7 = value$1.stockKeepingUnit;
        let value$8 = value$1.purchasedPrice;
        let value$9 = value$1.cku;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            margin: value$1.margin,
            marginRate: value$1.marginRate,
            markupRate: value$1.markupRate,
            totalPurchaseCost: value$1.totalPurchaseCost,
            revenueIncludingTaxes: value$1.revenueIncludingTaxes,
            revenueExcludingTaxes: value$1.revenueExcludingTaxes,
            occurrences: value$1.occurrences,
            quantity: value$1.quantity,
            capacityPrecision: !(value$2 == null) ? value$2 : undefined,
            capacityUnit: !(value$3 == null) ? value$3 : undefined,
            name: value$1.name,
            color: tmp,
            kind: tmp$2,
            stockRawQuantity: !(value$6 == null) ? value$6 : undefined,
            stockKeepingUnit: !(value$7 == null) ? value$7 : undefined,
            purchasedPrice: !(value$8 == null) ? value$8 : undefined,
            cku: !(value$9 == null) ? value$9 : undefined,
            description: value$1.description,
            variantId: value$1.variantId
          }
        };
      }),
      totalCount: value$1.totalCount
    }
  };
}

function serialize(value) {
  let value$1 = value.topPerformingProducts;
  let value$2 = value$1.totalCount;
  let value$3 = value$1.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.variantId;
    let value$3 = value$1.description;
    let value$4 = value$1.cku;
    let cku = value$4 !== undefined ? value$4 : null;
    let value$5 = value$1.purchasedPrice;
    let purchasedPrice = value$5 !== undefined ? value$5 : null;
    let value$6 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$6 !== undefined ? value$6 : null;
    let value$7 = value$1.stockRawQuantity;
    let stockRawQuantity = value$7 !== undefined ? value$7 : null;
    let value$8 = value$1.kind;
    let kind = value$8 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        value$8 === "BEER" ? "BEER" : (
            value$8 === "WINE" ? "WINE" : "SIMPLE"
          )
      );
    let value$9 = value$1.color;
    let color = value$9 !== undefined ? (
        value$9 === "ORANGE" ? "ORANGE" : (
            value$9 === "RED" ? "RED" : (
                value$9 === "AMBER" ? "AMBER" : (
                    value$9 === "DARK" ? "DARK" : (
                        value$9 === "BLACK" ? "BLACK" : (
                            value$9 === "BLOND" ? "BLOND" : (
                                value$9 === "ROSE" ? "ROSE" : "WHITE"
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    let value$10 = value$1.name;
    let value$11 = value$1.capacityUnit;
    let capacityUnit = value$11 !== undefined ? value$11 : null;
    let value$12 = value$1.capacityPrecision;
    let capacityPrecision = value$12 !== undefined ? value$12 : null;
    let value$13 = value$1.quantity;
    let value$14 = value$1.occurrences;
    let value$15 = value$1.revenueExcludingTaxes;
    let value$16 = value$1.revenueIncludingTaxes;
    let value$17 = value$1.totalPurchaseCost;
    let value$18 = value$1.markupRate;
    let value$19 = value$1.marginRate;
    let value$20 = value$1.margin;
    let value$21 = value$1.__typename;
    let node = {
      __typename: value$21,
      margin: value$20,
      marginRate: value$19,
      markupRate: value$18,
      totalPurchaseCost: value$17,
      revenueIncludingTaxes: value$16,
      revenueExcludingTaxes: value$15,
      occurrences: value$14,
      quantity: value$13,
      capacityPrecision: capacityPrecision,
      capacityUnit: capacityUnit,
      name: value$10,
      color: color,
      kind: kind,
      stockRawQuantity: stockRawQuantity,
      stockKeepingUnit: stockKeepingUnit,
      purchasedPrice: purchasedPrice,
      cku: cku,
      description: value$3,
      variantId: value$2
    };
    let value$22 = value.__typename;
    return {
      __typename: value$22,
      node: node
    };
  });
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let topPerformingProducts = {
    __typename: value$8,
    pageInfo: pageInfo,
    edges: edges,
    totalCount: value$2
  };
  return {
    topPerformingProducts: topPerformingProducts
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectTopPerformingProductsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.startDate;
  let a$2 = inp.endDate;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    startDate: a$1 !== undefined ? a$1 : undefined,
    endDate: a$2 !== undefined ? a$2 : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  let a$1 = inp.sortBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectTopPerformingProductsQueryFilter(a) : undefined,
    sortBy: a$1 !== undefined ? (
        a$1 === "QUANTITY" ? "QUANTITY" : (
            a$1 === "REVENUE_INCLUDING_TAXES" ? "REVENUE_INCLUDING_TAXES" : "MARGIN"
          )
      ) : undefined
  };
}

function makeVariables(filterBy, sortBy) {
  return {
    filterBy: filterBy,
    sortBy: sortBy
  };
}

function makeInputObjectTopPerformingProductsQueryFilter(shopIds, startDate, endDate, param) {
  return {
    shopIds: shopIds,
    startDate: startDate,
    endDate: endDate
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined,
    sortBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectTopPerformingProductsQueryFilter: serializeInputObjectTopPerformingProductsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectTopPerformingProductsQueryFilter: makeInputObjectTopPerformingProductsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectTopPerformingProductsQueryFilter: serializeInputObjectTopPerformingProductsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectTopPerformingProductsQueryFilter: makeInputObjectTopPerformingProductsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

let values = [
  "Quantity",
  "RevenueIncludingTaxes",
  "Margin"
];

function toLabel(value) {
  switch (value) {
    case "Quantity" :
      return I18n.t("Sold quantity");
    case "RevenueIncludingTaxes" :
      return I18n.t("Revenue");
    case "Margin" :
      return I18n.t("Margin");
  }
}

function toRawString(value) {
  switch (value) {
    case "Quantity" :
      return "QUANTITY";
    case "RevenueIncludingTaxes" :
      return "REVENUE_INCLUDING_TAXES";
    case "Margin" :
      return "MARGIN";
  }
}

function toQueryVariableValue(value) {
  switch (value) {
    case "Quantity" :
      return "QUANTITY";
    case "RevenueIncludingTaxes" :
      return "REVENUE_INCLUDING_TAXES";
    case "Margin" :
      return "MARGIN";
  }
}

let SortBy = {
  values: values,
  toLabel: toLabel,
  toRawString: toRawString,
  toQueryVariableValue: toQueryVariableValue
};

function encoder(param) {
  let match = param.dateRange;
  return [
    param.shop.id,
    [
      match[0].getTime(),
      match[1].getTime()
    ]
  ];
}

function decoder(shops, param) {
  let dateRange = param[1];
  let shopId = param[0];
  let maybeShop = shops.find(shop => shop.id === shopId);
  let startDate = dateRange[0];
  let endDate = dateRange[1];
  return {
    TAG: "Ok",
    _0: {
      shop: maybeShop !== undefined ? maybeShop : shops[0],
      dateRange: [
        new Date(startDate),
        new Date(endDate)
      ]
    }
  };
}

function useJsonCodec() {
  let shops = Auth.useShops();
  return JsonCodec.object2(encoder, arg => decoder(shops, arg), JsonCodec.field("shopId", JsonCodec.string), JsonCodec.field("dateRange", JsonCodec.array(JsonCodec.float)));
}

let Filters = {
  encoder: encoder,
  decoder: decoder,
  useJsonCodec: useJsonCodec
};

function unapplyArbitraryPrecision(quantity, precision) {
  return quantity / Math.pow(10, precision);
}

function formatStockQuantity(quantity, capacity) {
  if (typeof capacity !== "object") {
    return I18n.decimalFormat(undefined, undefined, undefined, undefined, quantity);
  }
  let unit = capacity._0;
  let quantity$1 = unapplyArbitraryPrecision(quantity, capacity._1);
  if (unit.TAG === "Intl") {
    return I18n.unitFormat(unit._0, undefined, undefined, quantity$1);
  } else {
    return I18n.decimalFormat(undefined, undefined, undefined, undefined, quantity$1) + " " + unit._0;
  }
}

function formatPurchasedPrice(value, capacity, currency) {
  if (typeof capacity !== "object") {
    return I18n.currencyFormat(undefined, currency, undefined, 3, value);
  }
  let unit = capacity._0;
  let tmp;
  tmp = unit.TAG === "Intl" ? I18n.numberUnitToString(unit._0) : unit._0;
  return I18n.currencyFormat(undefined, currency, undefined, 3, value) + "/" + tmp;
}

function fromQueryDataEdge(param) {
  let node = param.node;
  let match = node.capacityPrecision;
  let match$1 = node.capacityUnit;
  let capacity;
  if (match !== undefined && match$1 !== undefined) {
    switch (match$1) {
      case "G" :
      case "g" :
        capacity = {
          TAG: "Bulk",
          _0: {
            TAG: "Intl",
            _0: "gram"
          },
          _1: match
        };
        break;
      case "KG" :
      case "kg" :
        capacity = {
          TAG: "Bulk",
          _0: {
            TAG: "Intl",
            _0: "kilogram"
          },
          _1: match
        };
        break;
      case "L" :
      case "l" :
        capacity = {
          TAG: "Bulk",
          _0: {
            TAG: "Intl",
            _0: "liter"
          },
          _1: match
        };
        break;
      default:
        capacity = {
          TAG: "Bulk",
          _0: {
            TAG: "NonIntl",
            _0: match$1
          },
          _1: match
        };
    }
  } else {
    capacity = "Unit";
  }
  let tmp;
  tmp = typeof capacity !== "object" ? node.quantity : node.occurrences;
  let tmp$1;
  tmp$1 = typeof capacity !== "object" ? undefined : formatStockQuantity(node.quantity, capacity);
  return {
    margin: I18n.currencyFormat(undefined, "EUR", undefined, undefined, node.margin),
    marginRate: I18n.percentFormat(undefined, 2, 2, node.marginRate / 100),
    markupRate: I18n.percentFormat(undefined, 2, 2, node.markupRate / 100),
    totalPurchaseCost: I18n.currencyFormat(undefined, "EUR", undefined, undefined, node.totalPurchaseCost),
    revenueIncludingTaxes: node.revenueIncludingTaxes,
    revenueExcludingTaxes: node.revenueExcludingTaxes,
    unitSoldQuantity: tmp,
    bulkSoldQuantity: tmp$1,
    stockQuantity: Stdlib_Option.mapOr(node.stockRawQuantity, "0", v => formatStockQuantity(v, capacity)),
    purchasedPrice: Stdlib_Option.mapOr(node.purchasedPrice, "—", v => formatPurchasedPrice(v, capacity, "EUR")),
    name: node.name,
    color: node.color,
    kind: node.kind,
    stockKeepingUnit: node.stockKeepingUnit,
    cku: node.cku,
    description: node.description,
    variantId: node.variantId
  };
}

let Row = {
  unapplyArbitraryPrecision: unapplyArbitraryPrecision,
  formatStockQuantity: formatStockQuantity,
  formatPurchasedPrice: formatPurchasedPrice,
  fromQueryDataEdge: fromQueryDataEdge
};

function makeQueryVariables(defaultQueryVariables, connectionArguments, search, filterBy, param) {
  return {
    filterBy: filterBy,
    sortBy: defaultQueryVariables.sortBy
  };
}

function makeQueryVariablesFilterBy(param) {
  let match = param.dateRange;
  return {
    shopIds: {
      _in: [param.shop.id]
    },
    startDate: Scalar.Datetime.serialize(match[0]),
    endDate: Scalar.Datetime.serialize(match[1])
  };
}

function totalCountFromQueryData(param) {
  return param.topPerformingProducts.totalCount;
}

function cursorsFromQueryData(param) {
  let topPerformingProducts = param.topPerformingProducts;
  return [
    topPerformingProducts.pageInfo.startCursor,
    topPerformingProducts.pageInfo.endCursor
  ];
}

function rowsFromQueryDataAndState(param, param$1) {
  let currentPage = param$1.currentPage;
  return param.topPerformingProducts.edges.slice((currentPage - 1 | 0) * Scaffold.edgesPerPage | 0, currentPage * Scaffold.edgesPerPage | 0).map(fromQueryDataEdge);
}

function keyExtractor(param) {
  return param.variantId;
}

let Scaffolded = Scaffold.Make({
  useFiltersJsonCodec: useJsonCodec,
  QueryInner: Query_inner,
  useQuery: use,
  makeQueryVariables: makeQueryVariables,
  makeQueryVariablesFilterBy: makeQueryVariablesFilterBy,
  cursorsFromQueryData: cursorsFromQueryData,
  totalCountFromQueryData: totalCountFromQueryData,
  rowsFromQueryDataAndState: rowsFromQueryDataAndState,
  keyExtractor: keyExtractor
});

let scaffoldedColumns = [
  {
    name: I18n.t("Name & description"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 250
      },
      width: {
        NAME: "fr",
        VAL: 3.5
      },
      margin: "xxlarge",
      sticky: true
    },
    render: param => {
      let pastilleColor = Stdlib_Option.map(param.color, color => CatalogProduct.Color.toColorSet(color, "pastille").foregroundColor);
      let description = Stdlib_Option.mapOr(param.stockKeepingUnit, "", sku => `SKU` + I18n.t(":") + ` ` + sku + `, `) + param.description;
      return JsxRuntime.jsx(LegacyProductReferenceTableCell.make, {
        cku: param.cku,
        name: param.name,
        pastilleColor: pastilleColor,
        description: description
      });
    }
  },
  {
    name: I18n.t("Sold Quantity"),
    layout: {
      alignX: "center"
    },
    render: param => {
      let bulkSoldQuantity = param.bulkSoldQuantity;
      return JsxRuntime.jsx(Inline.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: param.unitSoldQuantity
            }),
            bulkSoldQuantity !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                children: I18n.template(I18n.t("For {{value}}"), {
                  value: bulkSoldQuantity
                }, undefined),
                variation: "subdued",
                size: "xxsmall"
              }) : null
          ]
        }),
        align: "center"
      });
    }
  },
  {
    name: I18n.t("Revenue excl. VAT"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 110
      },
      margin: "small"
    },
    render: param => JsxRuntime.jsx(AmountTableCell.make, {
      value: param.revenueExcludingTaxes,
      secondaryValue: param.revenueIncludingTaxes
    })
  },
  {
    name: I18n.t("Margin"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 135
      },
      width: {
        NAME: "fr",
        VAL: 1.5
      },
      margin: "large",
      alignX: "flexEnd"
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.margin,
      weight: "semibold"
    })
  },
  {
    name: I18n.t("Margin/Markup rt"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 100
      },
      width: {
        NAME: "fr",
        VAL: 1.5
      }
    },
    render: param => JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(TextStyle.make, {
          children: param.marginRate
        }),
        JsxRuntime.jsx(TextStyle.make, {
          children: param.markupRate,
          variation: "normal",
          size: "xxsmall"
        })
      ],
      space: "xxsmall"
    })
  },
  {
    name: I18n.t("Cost of sales"),
    layout: {
      width: {
        NAME: "fr",
        VAL: 1.5
      },
      alignX: "flexEnd"
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.totalPurchaseCost
    })
  },
  {
    name: I18n.t("Purchase price"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 110
      },
      alignX: "flexEnd"
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.purchasedPrice
    })
  },
  {
    name: I18n.t("Stock"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 75
      },
      alignX: "center"
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.stockQuantity
    })
  }
];

let now = new Date();

let initialDateRange_0 = DateHelpers.startOfDay(now);

let initialDateRange_1 = DateHelpers.endOfDay(now);

let initialDateRange = [
  initialDateRange_0,
  initialDateRange_1
];

function AnalyticsTopPerformingProductsPage(props) {
  let scope = Auth.useScope();
  let organisationAccount;
  organisationAccount = scope.TAG === "Organisation";
  let activeShop;
  if (scope.TAG === "Organisation") {
    let shop = scope.activeShop;
    activeShop = shop !== undefined ? shop : scope.shops[0];
  } else {
    activeShop = scope._0;
  }
  let initialState = Scaffolded.makeInitialState({
    shop: activeShop,
    dateRange: initialDateRange
  });
  let match = Scaffolded.use(() => initialState);
  let dispatch = match[1];
  let state = match[0];
  let match$1 = React.useState(() => "Quantity");
  let setSortBy = match$1[1];
  let sortBy = match$1[0];
  let defaultQueryVariables_sortBy = toQueryVariableValue(sortBy);
  let defaultQueryVariables = {
    filterBy: undefined,
    sortBy: defaultQueryVariables_sortBy
  };
  let items = values.map(value => ({
    TAG: "Option",
    key: toRawString(value),
    label: toLabel(value),
    value: value
  }));
  let filters = JsxRuntime.jsxs(Inline.make, {
    children: [
      organisationAccount ? JsxRuntime.jsx(Auth.SelectSingleShopFilter.make, {
          value: state.filters.shop,
          onChange: shop => dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shop: shop,
              dateRange: prev.dateRange
            })
          })
        }) : null,
      organisationAccount ? JsxRuntime.jsx(CanarySeparator.make, {}) : null,
      JsxRuntime.jsx(Select.make, {
        label: I18n.t("Sorting"),
        preset: "filter",
        sections: [{
            items: items
          }],
        value: {
          TAG: "Single",
          _0: sortBy
        },
        onChange: change => {
          if (change.TAG !== "Single") {
            return;
          }
          let value = change._0;
          setSortBy(param => Stdlib_Option.getExn(value, undefined));
        }
      }),
      JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.dateRange,
        placeholder: I18n.t("Select a period"),
        hideResetButton: true,
        onChange: dateRange => {
          let dateRange$1 = Stdlib_Option.getOr(dateRange, initialDateRange);
          dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shop: prev.shop,
              dateRange: dateRange$1
            })
          });
        },
        triggerLabelDisplay: "showPreset"
      })
    ],
    space: "small"
  });
  let emptyState = JsxRuntime.jsx(EmptyState.make, {
    illustration: Illustration.noResultFound,
    title: I18n.t("No result were found."),
    text: I18n.t("Try again with different filters.")
  });
  return JsxRuntime.jsx(Scaffolded.make, {
    title: I18n.t("Top sold products"),
    state: state,
    dispatch: dispatch,
    columns: scaffoldedColumns,
    filters: filters,
    emptyState: emptyState,
    defaultQueryVariables: defaultQueryVariables
  });
}

let make = React.memo(AnalyticsTopPerformingProductsPage);

export {
  Query,
  SortBy,
  Filters,
  Row,
  Scaffolded,
  scaffoldedColumns,
  initialDateRange,
  make,
}
/* query Not a pure module */
